import {Component, inject} from '@angular/core'
import {MatCheckbox} from '@angular/material/checkbox'
import {TestService} from '../../services/test.service'

@Component({
  selector: 'spb-test',
  templateUrl: './test.component.html',
  styleUrls: ['./test.component.scss'],
  imports: [MatCheckbox]
})
export class TestComponent {
  public testService = inject(TestService)

  public setLinear(): void {
    this.testService.linear = !this.testService.linear
  }
}
